<template>
  <!-- class="page topSpace" -->
  <div :class="$style.page">
    <div :class="$style.header">
      <div :class="$style.headerInner">
        <img
          src="@/assets/icon.png"
          :class="[$style.logo]"
          @click="$router.push('/')"
        >
        <div :class="[$style.nav]">
          <div
            :class="[$style.navItem,{
              ['hlr']:$route.name==='About'
            }]"
            @click="$router.push($route.name==='About'?'/':'/services')"
          >
            服务
          </div>
          <div
            :class="[$style.navItem,{
              ['hlr']:$route.name==='JoinUs'
            }]"
            @click="$router.push($route.name==='JoinUs'?'/':'/joinus')"
          >
            加入
          </div>
        </div>
      </div>
    </div>

    <!-- kv -->
    <div
      :class="[$style.kv,{
        [$style.fullScreen]: $route.name!=='KeyView'

      }]"
    >
      <transition
        name="kv"
        appear
      >
        <router-view
          :content="content"
        />
      </transition>
    </div>

    <!-- 日志 -->
    <div :class="$style.journal">
      <!-- 列表头 -->
      <div :class="$style.journalHeader">
        <div
          :class="$style.journalTitle"
          class="row"
        >
          <h2 class="col">
            <span>{{ content.soJournalEn }}</span>
            <span>{{ content.soJournalCn }}</span>
          </h2>
          <img
            :class="$style.svgTextLogo"
            src="@/assets/slash.svg"
            width="30"
          >
          <!-- todo 做成组件 -->
          <h3>{{ journal[0] && new Date(journal[0].publishedAt).getMonth()+1+'月' }} {{ journal[0] && journal[0].title }}</h3>
          <small>/查阅更多/</small>
        </div>

        注意，feed可以做这样的改进，你把它当成一个ins就可以了，不一定真要跳到某个详情去的，文字内容前置到列表页面，可以附链接甚至多个链接

        <!-- 分类 -->
        <div :class="$style.cate">
          <template
            v-for="(item,index) in categories"
          >
            <span :key="index">
              {{ item }}
            </span>
            /
          </template>
          ...
        </div>
      </div>

      <div :class="$style.feed">
        <FeedItem
          v-for="(item,index) in feed"
          :key="index"
          :data="item"
        />

        <FeedItem />
        <FeedItem />
        <FeedItem />
      </div>
    </div>
  </div>
</template>

<script>
// components
import FeedItem from '@/components/FeedItem.vue'

export default {
  name: 'Home',
  components: { FeedItem },
  data () {
    return {
      kvOpen: false,
      content: {},
      journal: [],
      articles: [],
      jobs: []
    }
  },
  computed: {
    feed () {
      let res = []
      for (let i = 0; i < this.articles.length; i++) {
        let el = this.articles[i]
        res = res.concat(el)
      }
      return res
    },
    categories () {
      let arr = []
      let obj = {}
      let res = []

      for (let i = 0; i < this.articles.length; i++) {
        let el = this.articles[i]
        arr = arr.concat(el.tags)
      }
      for (let i = 0; i < arr.length; i++) {
        let el = arr[i]
        obj[el] = 1
      }
      for (let key in obj) {
        res.push(key)
      }
      return res
    }
  },
  methods: {
    getPageData () {
      this.$cloud.query('/data/page.home.json', data => {
        let res = data
        this.$set(this, 'content', res)
      })
    },
    getJournalData () {
      this.$cloud.query('/data/journal.json', data => {
        let res = data.list
        this.journal = res
      })
    },
    getArticlesData () {
      this.$cloud.query('/data/articles.json', data => {
        let res = data.list
        this.articles = res
      })
    },
    getJobsData () {
      this.$cloud.query('/data/jobs.json', data => {
        let res = data.list
        this.jobs = res
      })
    }
  },
  // watch: {
  //   $route (to, from) {
  //     // setTimeout(() => {
  //     this.kvOpen = to.name !== 'KeyView'
  //     // }, 500)
  //   }
  // },
  created () {
    // this(this.$route.name)
    this.getPageData()
    this.getJournalData()
    this.getArticlesData()
    this.getJobsData()
  }
  // data () {
  //   return {
  //     contents
  //   }
  // }
}
</script>

<style module>
.header {
  position: absolute;
  width: 100%;
  /* background: rgba(0, 31, 78, 0.2); */
  z-index: 1;
}

.headerInner {
  position: relative;
  /* background: rgba(255,0,0,.2); */
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  transform: translateY(70px);
}

.logo {
  width: 56px;
  cursor: pointer;
  /* height: 43px; */
}

.nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* background: rgba(255,0,0,.2); */
}

.navItem {
  /* background: rgba(255,0,0,.2); */
  font-weight: bold;
  font-size: 18px;
  padding: 0 24px;
  user-select: none;
  cursor:pointer;
}

.kv {
  position: relative;
  width: 100%;
  top: 0;
  height: 65vh;

  background: #F9F9F9;
  transition-duration: 0.7s;

  will-change: transform;
  transform: translateZ(0);
}

.fullScreen {
  height: 130vh;
}

/* .openBox {
  animation: openBox 1s .5s 1 forwards;
} */
/*  */
/* @keyframes openBox {
  0% {
    height: 100vh;
  }
  100% { */
    /* min-height: 100vh; */
    /* height: unset; */
  /* }
} */

.journal {
  position: relative;
  padding: 128px 64px;
  /* background: rgba(255,0,0,.2); */
  margin: 0 auto;
  width: 100%;
  max-width: 1440px;
  box-sizing: border-box;
}

.journalHeader {
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  width: 100%;
  /* max-width: 1440px; */
}

.journalTitle{
  /* background: rgba(255,0,0,.2); */
}

.cate{
  /* background: rgba(255,0,0,.2); */
}

.feed {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
</style>

<style>
.kv-item {
  /* display: inline-block; */
  /* margin-right: 10px; */
  will-change: transform;
  transform: translateZ(0);
}
.kv-enter-active  ,.kv-leave-active {
  transition-duration: .5s !important;
}
.kv-enter, .kv-leave-to
/* .kv-leave-active for below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(50px);
}

.kvPage-leave-to, .kvPage-enter{
  opacity: 0;
}

.kvPage-enter-active {
  transition-duration: .5s !important;
}
</style>
